<nz-layout>
    <nz-content class="table-container">
        <div class="table-wrapper" (scroll)="onScroll($event)" (scrollend)="onScrollEnd($event)" #scroll>
            <table-pro [config]="config!" [currentPage]="1" [currentPageSize]="1000" [tableData]="[]" [stickyTop]="40"
                [highLightKey]="'workFlowKey'" (queryPanelStateChange)="queryPanelStateChange($event)"
                (resetClick)="resetSearch()" (searchClick)="searchClick($event)">

                <div class="grid overview" overview>
                    <div class="row">
                        <div class="column no-border" [style.width]="'150px'">
                            <nz-cascader class="color-primary" (ngModelChange)="onSectionChange()"
                                [nzOptions]="cascaderOptions" [(ngModel)]="cascaderValue" [nzShowSearch]="true"
                                [nzPlaceHolder]="'选择标段'" [nzAllowClear]="false">
                            </nz-cascader>
                        </div>
                        <div class="column no-border" [style.width]="'300px'" *ngIf="cascaderValue.length > 0">
                            <nz-select class="color-primary" [(ngModel)]="mainRequest.dwCode" [nzAllowClear]="false"
                                (ngModelChange)="resetSearch()">
                                <nz-option [nzLabel]="'全部单位工程'" [nzValue]="''"></nz-option>
                                <nz-option *ngFor="let item of inspUnitDwList"
                                    [nzLabel]="item.dwCode + ' ' + item.dwName" [nzValue]="item.dwCode">
                                </nz-option>
                            </nz-select>
                        </div>
                        <div class="column no-border" [style.width]="'10rem'">
                            <b>实体检测</b>
                        </div>
                    </div>

                    <div class="action-bar" [style.left]="'40rem'">
                        <button nz-button nzType="text" (click)="goQuestCheck()"
                            [disabled]="currentUserType !== OrganizationType.CONSTRUCTION"
                            class="{{currentUserType !== OrganizationType.CONSTRUCTION ? 'color-light' : 'color-primary'}}">
                            + 交工检测
                        </button>
                        <button nz-button nzType="text" [disabled]="currentUserType !== OrganizationType.CONSTRUCTION"
                            class="{{currentUserType !== OrganizationType.CONSTRUCTION ? 'color-light' : 'color-primary'}}">
                            ↑上传交工报检单
                            <input type="file" (change)="uploadReport($event, false)" accept=".pdf"
                                *ngIf="currentUserType === OrganizationType.CONSTRUCTION">
                        </button>
                        <button
                            class="{{currentUserType !== OrganizationType.JG_CHECK ? 'color-light' : 'color-primary'}}"
                            nz-button nzType="text" [disabled]="currentUserType !== OrganizationType.JG_CHECK">+ 交工检测报告
                            <input *ngIf="currentUserType === OrganizationType.JG_CHECK" type="file"
                                (change)="uploadReport($event, true)" accept=".pdf">
                        </button>
                        <button class="color-primary" nz-button nzType="text" (click)="goQuestView()">◳ 交工检测视图</button>
                    </div>
                </div>

                <div body>
                    <table [style.left]="0" [style.width]="totalWidth + 'px'">
                        <colgroup>
                            <col span="1" [style.width]="(56 * 100 / totalWidth) + '%'">
                            <col span="1" *ngFor="let col of config?.columns ?? []"
                                [style.width]="(col.width * 100 / totalWidth) + '%'">
                        </colgroup>
                        <tr *ngFor="let item of recordList ?? []; let index = index;">

                            <td [style.textAlign]="'center'"
                                class="{{index + 1 < recordList.length && recordList[index].dwCode !==  recordList[index + 1].dwCode ? 'border-bottom-black' : ''}}">
                                {{index + 1}}
                            </td>

                            <td
                                class="{{index + 1 < recordList.length && recordList[index].dwCode !==  recordList[index + 1].dwCode ? 'border-bottom-black' : ''}} border-right-black">
                                <!-- <span class="color-light">{{item.dwCode}}</span>
                                <span
                                    class="{{index > 0 && recordList[index - 1].dwCode ===  recordList[index].dwCode ? 'color-light' : ''}}">
                                    {{item.dwName}}
                                </span> -->
                                <format-data [contentStr]="item.dwCode + ' ' + item.dwName"
                                    [patternStr]="'E+120@@' + (index > 0 && recordList[index - 1].dwCode ===  recordList[index].dwCode ? 'Cbdc3c7' : 'Cbdc3c70,' + item.dwCode?.length)"></format-data>
                            </td>

                            <td
                                class="{{index + 1 < recordList.length && (recordList[index].dwCode !==  recordList[index + 1].dwCode || recordList[index].jgFbName !== recordList[index + 1].jgFbName) ? 'border-bottom-black' : ''}}  border-right-black">
                                <span
                                    class="{{index > 0 && recordList[index - 1].jgFbName ===  recordList[index].jgFbName && recordList[index - 1].dwCode ===  recordList[index].dwCode ? 'color-light' : ''}}">
                                    {{item.jgFbName}}
                                </span>
                            </td>

                            <td
                                class="{{index + 1 < recordList.length && (recordList[index].dwCode !==  recordList[index + 1].dwCode || recordList[index].jgFbName !== recordList[index + 1].jgFbName || recordList[index].jgFxProjectTypeName !== recordList[index + 1].jgFxProjectTypeName) ? 'border-bottom-black' : ''}}">
                                <b
                                    class="{{index > 0 && recordList[index - 1].jgFbName ===  recordList[index].jgFbName && recordList[index - 1].jgFxName ===  recordList[index].jgFxName && recordList[index - 1].dwCode ===  recordList[index].dwCode ? 'color-light' : ''}}">
                                    {{item.jgFxName}}
                                </b>
                            </td>

                            <td
                                class="{{index + 1 < recordList.length && (recordList[index].dwCode !==  recordList[index + 1].dwCode || recordList[index].jgFbName !== recordList[index + 1].jgFbName || recordList[index].jgFxProjectTypeName !== recordList[index + 1].jgFxProjectTypeName) ? 'border-bottom-black' : ''}}">
                                {{item.jgInspItemName}}</td>
                            <td [style.textAlign]="'center'" [style.paddingRight]="4 + 'px'"
                                class="{{index + 1 < recordList.length && (recordList[index].dwCode !==  recordList[index + 1].dwCode || recordList[index].jgFbName !== recordList[index + 1].jgFbName || recordList[index].jgFxProjectTypeName !== recordList[index + 1].jgFxProjectTypeName) ? 'border-bottom-black' : ''}} ">
                                <b class="color-success" *ngIf="!!item.completedCount">
                                    {{item.completedCount}}
                                </b>
                            </td>
                            <td [style.textAlign]="'center'" [style.paddingRight]="4 + 'px'"
                                class="{{index + 1 < recordList.length && (recordList[index].dwCode !==  recordList[index + 1].dwCode || recordList[index].jgFbName !== recordList[index + 1].jgFbName || recordList[index].jgFxProjectTypeName !== recordList[index + 1].jgFxProjectTypeName) ? 'border-bottom-black' : ''}} ">
                                <b class="color-primary" *ngIf="!!item.inspectedCount">
                                    {{item.inspectedCount}}
                                </b>
                            </td>
                            <td [style.textAlign]="'center'" [style.paddingRight]="4 + 'px'"
                                class="{{index + 1 < recordList.length && (recordList[index].dwCode !==  recordList[index + 1].dwCode || recordList[index].jgFbName !== recordList[index + 1].jgFbName || recordList[index].jgFxProjectTypeName !== recordList[index + 1].jgFxProjectTypeName) ? 'border-bottom-black' : ''}} ">
                                <b *ngIf="!!item.designedCount">
                                    {{item.designedCount}}
                                </b>
                            </td>
                            <td
                                class="{{index + 1 < recordList.length && (recordList[index].dwCode !==  recordList[index + 1].dwCode || recordList[index].jgFbName !== recordList[index + 1].jgFbName || recordList[index].jgFxProjectTypeName !== recordList[index + 1].jgFxProjectTypeName) ? 'border-bottom-black' : ''}}">
                                <div class="block">
                                    <div class="form full">
                                        <span *ngFor="let form of item.rfiList" (click)="sign(form.workFlowKey!)"
                                            class="clickable" [style.color]="getColor(form.status!)">
                                            {{form.formDisplayName}}
                                        </span>
                                    </div>
                                </div>
                            </td>
                            <td
                                class="{{index + 1 < recordList.length && (recordList[index].dwCode !==  recordList[index + 1].dwCode || recordList[index].jgFbName !== recordList[index + 1].jgFbName || recordList[index].jgFxProjectTypeName !== recordList[index + 1].jgFxProjectTypeName) ? 'border-bottom-black' : ''}}  border-right-black">
                                <div class="block">
                                    <div class="form full">
                                        <span *ngFor="let form of item.hirList" (click)="sign(form.workFlowKey!)"
                                            class="clickable color-primary">
                                            {{form.formDisplayName}}
                                        </span>
                                    </div>
                                </div>
                            </td>
                        </tr>
                    </table>

                </div>
            </table-pro>
        </div>
    </nz-content>

    <nz-footer class="footer">
        <nz-pagination [nzPageIndex]="pager.pageIndex" [(nzPageSize)]="pager.pageSize"
            [nzPageSizeOptions]="pager.pageSizeOptions" [nzTotal]="pager.total" nzShowQuickJumper
            [nzShowSizeChanger]="true" [nzShowQuickJumper]="true" (nzPageIndexChange)="pageIndexChange($event)"
            (nzPageSizeChange)="pageSizeChange($event)">
        </nz-pagination>
    </nz-footer>
</nz-layout>